import { digitsMask } from '@/utils/forms/inputMasks'

import { labelWithTooltip } from '../../RequiredLabel/labelWithTooltip'
import {
  type ConfigFieldContext,
  ConfigTextField,
} from '../ConfigFields/ConfigFields'
import {
  type ColumnKey,
  DUPLICATE_COLUMN_MESSAGE,
} from '../lib/configColumnConflicts'
import { CONFIG_TOOLTIPS } from '../lib/configModalTexts'

const COLUMN_PLACEHOLDER = 'A = 1, B = 2, C = 3'
const OPTIONAL_PLACEHOLDER = 'Можно не указывать'

type ConfigColumnFieldsProps = {
  context: ConfigFieldContext
  conflicts: Set<ColumnKey>
}

function ConfigColumnFields({ context, conflicts }: ConfigColumnFieldsProps) {
  const conflictError = (name: ColumnKey) =>
    conflicts.has(name) ? DUPLICATE_COLUMN_MESSAGE : undefined

  return (
    <>
      <ConfigTextField
        context={context}
        name="articleColumnNumber"
        error={conflictError('articleColumnNumber')}
        title="Колонка артикула (производителя)"
        required
        placeholder={COLUMN_PLACEHOLDER}
        mask={digitsMask}
      />
      <ConfigTextField
        context={context}
        name="articleInchColumnNumber"
        error={conflictError('articleInchColumnNumber')}
        title="Колонка артикула (поставщика)"
        placeholder={OPTIONAL_PLACEHOLDER}
        mask={digitsMask}
      />
      <ConfigTextField
        context={context}
        name="barcodeColumnNumber"
        error={conflictError('barcodeColumnNumber')}
        title="Колонка штрихкода"
        placeholder={OPTIONAL_PLACEHOLDER}
        mask={digitsMask}
      />
      <ConfigTextField
        context={context}
        name="descriptionColumnNumber"
        error={conflictError('descriptionColumnNumber')}
        title="Колонка наименования"
        required
        placeholder={COLUMN_PLACEHOLDER}
        mask={digitsMask}
      />
      <ConfigTextField
        context={context}
        name="brandColumnNumber"
        error={conflictError('brandColumnNumber')}
        title={labelWithTooltip('Колонка бренда', CONFIG_TOOLTIPS.brandColumn)}
        placeholder={OPTIONAL_PLACEHOLDER}
        mask={digitsMask}
      />
      <ConfigTextField
        context={context}
        name="quantityColumnNumber"
        error={conflictError('quantityColumnNumber')}
        title="Колонка остатка"
        required
        placeholder={COLUMN_PLACEHOLDER}
        mask={digitsMask}
      />
    </>
  )
}

export default ConfigColumnFields
